import React from "react";
import axios from "axios";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { Trash2, CheckCheck, Clock8, CircleUserRound } from "lucide-react";
import Swal from "sweetalert2";

export default function DemandeLoginNotification({ login, fun }) {

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Êtes-vous sûr ?',
            text: "Vous ne pourrez pas revenir en arrière !",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimez-le !',
            cancelButtonText: 'Annuler'
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`demand_logins/${id}`);
                fun();
                Swal.fire('Supprimé!', 'Demande de login effacée avec succès.', 'success');
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleValidation = async (id) => {
        const { value: formValues } = await Swal.fire({
            title: "Entrer mots de passe et date d'expiration d'utilisateur",
            html: `
                <input id="pass" class="swal2-input" placeholder="Mot de passe">
                <input id="expire" type="date" class="swal2-input">
            `,
            focusConfirm: false,
            preConfirm: () => {
                const pass = document.getElementById("pass").value;
                const expire = document.getElementById("expire").value;
                if (!pass || !expire) {
                    Swal.showValidationMessage("Tous les champs sont requis !");
                } else {
                    return { pass, expire };
                }
            }
        });

        if (formValues) {
            try {
                const { data: prospet } = await axios.get(`demand_logins/${id}`);
                const formData = {
                    name: prospet.name,
                    email: prospet.email,
                    role: 'Utilisateur',
                    expire: formValues.expire,
                    password: formValues.pass,
                    pass: formValues.pass,
                    phone: prospet.numero, // 'phone' correspond à 'numero'
                    societe: prospet.object, // 'societe' correspond à 'object'
                    adresse: prospet.adresse,
                    pays: prospet.pays,
                    post: prospet.post,
                    site: prospet.site,
                    prenom: prospet.prenom
                };
                const [userResponse, updateResponse] = await Promise.all([
                    axios.post('users', formData),
                    axios.put(`demand_logins/${id}`, { lu: true, expire: formValues.expire, pass: formValues.pass }),
                ]);

                if (userResponse.status === 201) {
                    NotificationManager.success('Utilisateur créé avec succès', 'Succès', 4000);
                } else {
                    NotificationManager.warning(userResponse.data.message, 'Erreur', 4000);
                }

                if (updateResponse.status === 200) {
                    fun();
                    NotificationManager.success('Demande de login validée avec succès', 'Validé', 4000);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const renderRow = (demande) => {
        const formattedDate = moment(demande.created_at).fromNow();
        const isRead = demande.lu;

        return (
            <tr key={demande.id}>
                <td>
                    <span style={{ color: "#263F8C" }} className="mr-2">
                        <CircleUserRound />
                    </span> 
                    <strong className="text-body">{demande.name}</strong>
                </td>
                <td>{demande.prenom}</td>
                <td>{demande.email}</td>
                <td>{demande.numero}</td>
                <td>{demande.object}</td>
                <td>{demande.post}</td>
                <td>{demande.site}</td>
                <td>
                    <span className={`badge badge-pill ${getBadgeClass(demande.priorisation)}`} style={{color: demande.priorisation === "Immédiat" ? '#fff' : ''}}>
                        {demande.priorisation}
                    </span>
                </td>
                <td>{demande.description}</td>
                <td>
                    <p className="text-muted">
                        {!isRead && (
                            <button onClick={() => handleValidation(demande.id)} type="button" className="btn btn-success btn-sm">
                                <CheckCheck size={20} strokeWidth={1.5} /> Valider
                            </button>
                        )}
                        <button onClick={() => handleDelete(demande.id)} type="button" className="btn btn-danger btn-sm ml-2">
                            <Trash2 size={20} strokeWidth={1.5} /> Supprimer
                        </button>
                        <br />
                        <Clock8 size={16} strokeWidth={1} /> <span className="text-secondary time">{formattedDate}</span>
                    </p>
                </td>
            </tr>
        );
    };

    const getBadgeClass = (priorisation) => {
        switch (priorisation) {
            case "Immédiat":
                return "badge-primary";
            case "Urgent":
                return "badge-danger";
            default:
                return "badge-dark";
        }
    };

    return (
        <div className="main-body">
            <div className="col">
                <div className="card mb-grid">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="card-header-title">Demande de login récente</div>
                    </div>
                    <div className="table-responsive-md">
                        <table className="table table-actions table-hover mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Nom</th>
                                    <th scope="col">Prénom</th>
                                    <th scope="col">E-mail</th>
                                    <th scope="col">Téléphone</th>
                                    <th scope="col">Société</th>
                                    <th scope="col">Post</th>
                                    <th scope="col">Site internet</th>
                                    <th scope="col">Priorisation</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {login && login.map(demande => renderRow(demande))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
